<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <!-- <list
      row-key="RecordId"
      ref="list"
      unit="过程数据"
      :page="page"
      :show-checkbox="multiple"
      :show-query="false"
      :query-params="params"
      :get-data-func="api.list"
      @check-change="checkChange"
      :reset-data-func="resetData"
      v-if="trendShow"
      urlHash="facility/equipment/processdata"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list> -->

    <el-form label-width="100px" :class="{ 'warning-form': data.WarnStatus === 1 }">
      <el-row>
        <el-col :span="12">
          <el-form-item label="模数" prop="Cycn">
            {{ data.Cycn }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="周期时间" prop="Ecyct">
            {{ data.Ecyct }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="射出起点" prop="Eiss">
            {{ data.Eiss }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最大射速" prop="Eivm">
            {{ data.Eivm }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最大射压" prop="Eipm">
            {{ data.Eipm }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="转保压时间" prop="Esipt">
            {{ data.Esipt }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="转保压压力" prop="Esipp">
            {{ data.Esipp }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="转保压位置" prop="Esips">
            {{ data.Esips }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="射出时间" prop="Eipt">
            {{ data.Eipt }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="射出终点位置" prop="Eipse">
            {{ data.Eipse }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="储料时间" prop="Eplst">
            {{ data.Eplst }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="储料终点" prop="Eplsse">
            {{ data.Eplsse }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最大储料压力" prop="Eplspm">
            {{ data.Eplspm }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产温度1" prop="Et1">
            {{ data.Et1 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产温度2" prop="Et2">
            {{ data.Et2 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产温度3" prop="Et3">
            {{ data.Et3 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产温度4" prop="Et4">
            {{ data.Et4 }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="生产温度5" prop="Et5">
            {{ data.Et5 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产温度6" prop="Et6">
            {{ data.Et6 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产温度7" prop="Et7">
            {{ data.Et7 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产温度8" prop="Et8">
            {{ data.Et8 }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="生产温度9" prop="Et9">
            {{ data.Et9 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产温度10" prop="Et10">
            {{ data.Et10 }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template> 
<script>
// import listMixin from '@/mixins/trend/list'
// import list from '@/components/common/trendsTable/list'

export default {
  mixins: [],
  components: {},
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: require('@/api/equipment/processdata').default,
      trendShow: true,
      params: {
        ProductName: '',
        MouldName: ''
      },
      tempParams: {
        //    ProgrammeType: 1
      },
      ids: [],
      data: {}
    }
  },
  methods: {
    getInfo(id) {
      console.log(id, 'get')
      this.api.getLastInfo(id).then(res => {
        this.data = res.Data
      })
    }
  }
}
</script>
<style scoped>
/* .warning-form :deep(.el-form-item__label), */
.warning-form :deep(.el-form-item__content) {
  color: #ff0000 !important;
}
</style>